module.exports = __webpack_public_path__ + "static/c76acc760a487154789773f6dda1a237e67ff4386e3e5d4f2ee99ba1480994ae-b747985e0e1885b9f91099dc9f4ae794.png";